/** @jsx jsx */
/* eslint-disable no-use-before-define */
import React from 'react'
import { jsx } from '@emotion/core'
import { format, mediaQueries, showModal } from '../../twd/all';

export default ({sectors, total, maturity, page=1} ={}) => {
    let size = 3
    let n = Math.max((page-1) * size,0)
    return sectors
        .slice(n, n + size)
        .map((s, i) => {
            return <Sector {...s} index={n + i + 1} key={i} totalTrades={total} maturity={maturity} />
        })
}

const Sector = ({label, total, maturity, index, issuers=[], totalTrades} = {}) => {

    let pct = Math.round(total / Math.max(totalTrades,1) * 100)

    return <React.Fragment>
    <div className="row">
    <div className="col-md-12">
        <hr aria-hidden="true" className="vertical-offset-xxs" />
        <label className="medium-header" style={{margin:0}}>
        {index}. {label}: {format.count(total)}
        </label>
        <label className="tiny-header">
        &nbsp; ({pct}% of total)
        </label>
    </div>
    </div>

    <div className="row">
    <div className="col-md-12 text-center" css={paddingCss}>
        <div className="progress"
            style={{position:'relative', height:'10px', backgroundColor:'#e4e4e4'}}>
            <div className="progress-bar"
                style={{width: pct + "%", backgroundColor:'green'}}
                ><span className="sr-only"></span></div>
        </div>
    </div>
    </div>

    <div className="row vertical-offset-xxs">
    <div className="col-md-12" css={paddingCss}>
    <div>
        <label className="label-small">Select issuer to view offerings:</label>
    </div>
    {
        issuers.map(({name, symbol}, key) => {
            return <button
                data-name='corporates-sector-activity-tag'
                key={key}
                className="tag text-truncate"
                css={tagCss}
                onClick={(e) => {
                let p = {
                    view:'offerings-modal',
                    name,
                    maturity,
                    params: {
                        persistToPreviousSearches: false,
                        holdInvType: ['C'],
                        holdSymbol:[symbol]
                    },
                    from: 'corporates',
                    source: e.target,
                }
                showModal(p)
            }}>{name}</button>
        })
    }
    </div>
    </div>
    </React.Fragment>
}

const tagCss = {
    [mediaQueries.notXs]: {
        maxWidth: '40%',
        margin: 0,
        marginRight: '5px'
    },

    [mediaQueries.xs]: {
        maxWidth: '130px'
    }
}

const paddingCss = {
    [mediaQueries.notXs]: {
        paddingLeft: '30px'
    },

    [mediaQueries.xs]: {
    }
}
